import React, { useCallback, useEffect } from "react";
import { Helmet } from "react-helmet";
import '../designcss/tutorialcss.css';


const DownloadFiles21 = () => {
    const handleDownload = useCallback(() => {
        const files = [
            { href: 'https://gitlab.com/albiemerporte/myecommerceandportfolio2023/-/raw/v1/public/tutorial21/tutorial21.zip?ref_type=heads&inline=false', download: 'tutorial21.zip' }
        ];

        files.forEach(file => {
            const link = document.createElement('a');
            link.href = file.href;
            link.download = file.download;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }, []);

    return (
        <a href="#" onClick={handleDownload}>Download Repository</a>
    );
};

const TutorialTwentyOne= () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Add Adsterra script to head only on this page */}
            {/*<AdScripts />*/}

            <div className="blogcontainer" id="tutorial16">

                <div className="tutorial-banner" onClick={() => window.open("https://www.singlobby.com", "_blank")}>
                    <img src="https://res.cloudinary.com/dywqyzge2/image/upload/v1772299116/singlobby_banner_sokjnf.png" />
                </div>

                <div className="card">
                    <h2>PyQt6 Tutorial: How to Delete Table Row with Checkbox and Button using QtDesigner | Python GUI Dev</h2>

                    <div className="fakeimg" style={{ height: "auto", width: "90%" }}>
                        <img 
                            src="https://img.youtube.com/vi/Os_NKlaj5k4/maxresdefault.jpg"
                            alt="Tutorial 21"
                            style={{ maxWidth: "100%", height: "auto" }}
                        />
                    </div>

                    <p style={{ whiteSpace: "pre-wrap" }}>
                    Welcome to this comprehensive PyQt6 tutorial where you'll learn how to delete a table row using checkboxes and buttons with QtDesigner in Python. This step-by-step guide covers GUI development, offering practical insights and coding examples to help you master PyQt6. Whether you're a beginner or an experienced Python developer, this tutorial will enhance your skills in building interactive and user-friendly applications. Follow along and discover how PyQt6 empowers you to create efficient and elegant graphical user interfaces.
                        <br /><strong>What you'll learn:</strong>
                        <ul>
                            <li>Setting up the PyQt6 environment</li>
                            <li>Designing the GUI with QtDesigner</li>
                            <li>Implementing checkbox and button functionality</li>
                            <li>Deleting table rows dynamically</li>
                            <li>Python GUI development best practices</li>
                        </ul>
                        Don't forget to like, share, and subscribe for more PyQt6 tutorials and Python GUI development content. Let's dive into the world of PyQt6 together and elevate your programming skills! If you have any questions or suggestions, feel free to leave them in the comments below. Happy coding!
                        <br /><br />
                        #Python #PyQt6 #QtDesigner #QTableWidget #DeleteRow #Checkbox #DesktopApps #Programming #GUI
                    </p>

                    <button className="seemore">
                        <DownloadFiles21 />
                    </button>
                </div>
            </div><br />
        </>
    );
};

export default TutorialTwentyOne;
